import { PatientEncounterReviewApi } from '../../../../../api';

const ReviewDataResolver = {
  getItemGroupRowSnapshotReviewStateBySignatureId(
    signatureId,
    { ssuPatientId, patientEncounterId, itemGroupId },
    hideLoader = true
  ) {
    if (signatureId) {
      return PatientEncounterReviewApi.getSignedItemGroupRowSnapshotReviewState(
        ssuPatientId,
        patientEncounterId,
        itemGroupId,
        signatureId,
        hideLoader
      );
    }

    return PatientEncounterReviewApi.getItemGroupRowSnapshotCraReviewState(
      ssuPatientId,
      patientEncounterId,
      itemGroupId,
      hideLoader
    );
  },

  getLogCheckSnapshotReviewStateBySignatureId(
    signatureId,
    { ssuPatientId, patientEncounterId, patientItemGroupId },
    hideLoader = true
  ) {
    if (signatureId) {
      return PatientEncounterReviewApi.getSignedLogCheckSnapshotReviewState(
        ssuPatientId,
        patientEncounterId,
        patientItemGroupId,
        signatureId,
        hideLoader
      );
    }

    return PatientEncounterReviewApi.getLogCheckSnapshotSraReviewState(
      ssuPatientId,
      patientEncounterId,
      patientItemGroupId,
      hideLoader
    );
  },

  getLogSnapshotReviewStateBySignatureId(
    signatureId,
    { ssuPatientId, patientEncounterId, itemGroupTemplateId },
    hideLoader = true
  ) {
    if (signatureId) {
      return PatientEncounterReviewApi.getSignedLogSnapshotReviewState(
        ssuPatientId,
        patientEncounterId,
        itemGroupTemplateId,
        signatureId,
        hideLoader
      );
    }

    return PatientEncounterReviewApi.getLogSnapshotCraReviewState(
      ssuPatientId,
      patientEncounterId,
      itemGroupTemplateId,
      hideLoader
    );
  }
};

export default ReviewDataResolver;
